module.exports = {
  toGregorianYear: (moment, format) => {
    var buddhishYear = moment.format('YYYY')
    var gregorianYear = (parseInt(buddhishYear) - 543).toString()
    return moment.format(format.replace('YYYY', gregorianYear).replace('YY', gregorianYear.substring(2, 4))).replace(buddhishYear, gregorianYear)
  },
}
